import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

import HeaderMenu from '../containers/HeaderMenu';

import * as routes from '../settings/_routesSettings';

class AuthPermissionRoute extends Component {

  state = {
    isAuth: false,
    userPermissions: [],
  }

  shouldComponentUpdate() {
    if (this.state.userPermissions !== this.props.userPermissions) {
      return true;
    } else {
      return false;
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isAuth !== prevProps.isAuth ||
      this.props.userPermissions !== prevProps.userPermissions) {
      this.setState({
        isAuth: this.props.isAuth,
        userPermissions: this.props.userPermissions,
      });
    }
  }

  render() {
    const {
      component: Component,
      ...rest
    } = this.props;

    return (
      <Route {...rest} component={(props) => (
        this.props.isAuth ? (
          this.props.userPermissions.includes(this.props.permission) ? (
            <div>
              <HeaderMenu />
              <Component {...props} />
            </div>
          ) : (
            <Redirect to={routes.DASHBOARD} />
          )
        ) : (
          <div>
            <HeaderMenu />
            <Component {...props} />
          </div>
        )
      )}
      />
    );
  }
}
const mapStateToProps = (state) => ({
  isAuth: state.auth.isAuth,
  userPermissions: state.auth.profilePermissions,
});

export default connect(mapStateToProps)(AuthPermissionRoute);